import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PERMISSION_REQUEST_ERRORS } from '../../enums/permission_request_error.enum';
import { GranteeIneligibleReasons } from '../../../common/enums/ineligible-scenarios.enum';

//TODO replace with actual endpoint when available
@Injectable({
    providedIn: 'root',
})
export class PinValidationService {
    private readonly httpClient = inject(HttpClient);


    /**
     * Validates a unique PIN against a token to authenticate a grantee.
     *
     * @param pin - The unique PIN to validate
     * @param token - The authentication token associated with the permission request
     * @returns Observable containing error status and optional grantee ineligibility reason
     *
     * @remarks
     * This API is used in the grantee flow to verify that a grantee has the correct PIN
     * to access their permission request. On any error, it returns RECORD_NOT_FOUND.
     * The API may also return a granteeIneligibleReason if the grantee cannot proceed
     * (e.g., ASSOCIATED_OR_CONTROL_PERSON or FOREIGN_ADDRESS).
     */
    validatePin(pin: string, token: string): Observable<{
        error: PERMISSION_REQUEST_ERRORS | null;
        granteeIneligibleReason?: GranteeIneligibleReasons;
    }> {
        return this.httpClient
            .post<{ error: PERMISSION_REQUEST_ERRORS | null; granteeIneligibleReason?: GranteeIneligibleReasons }>(
                `${environment.ZCI_API_BASE_URL}${environment.ZCI_API_ENDPOINTS.AUTHENTICATE_PIN}`,
                {
                    pin,
                    token,
                },
            )
            .pipe(
                catchError(() => {
                    return of({ error: PERMISSION_REQUEST_ERRORS.RECORD_NOT_FOUND });
                }),
            );
    }
}
